import BaseModel from "./baseModel";

export default class ManualVideoModel extends BaseModel {
  static endPoint = "manual-videos/";
}
